import { Component, effect, inject } from "@angular/core";
import { InmateSecureDocumentCountRepository, NavStore, ScreenStore } from "../../../../../shared/src/public-api";
import { Router } from "@angular/router";
import { JhmTableComponent } from "@shared/src/lib/components/jhm-table/jhm-table.component";

@Component({
	selector: "jhmc-secure-documents",
	imports: [JhmTableComponent],
	templateUrl: "./secure-documents.component.html",
	styleUrl: "./secure-documents.component.scss"
})
export class SecureDocumentsComponent
{
	public screenSize: string;
	readonly screenStore = inject(ScreenStore);
	readonly navStore = inject(NavStore);

	public constructor(
		public inmateSecureDocumentCountRepository: InmateSecureDocumentCountRepository,
		private router: Router)
	{
		effect(() => {
			this.screenSize = this.screenStore.screenSize();
		})
	}

	public openNav(): void
	{
		this.navStore.open();
	}

	public onNewDocumentClicked(): void
	{
		this.router.navigate(["secure-documents-upload"]);
	}
}
